function initOakmore(scope = document) {
  const part = new URLSearchParams(window.location.search).get('part');
  if (part) scope.querySelectorAll('[data-og-part]').forEach(input => { if (!input.value) input.value = part.slice(0, 250); });
  scope.querySelectorAll('[data-og-sort]').forEach(select => { if (select.dataset.ready) return; select.dataset.ready = 'true'; select.addEventListener('change', () => select.form.requestSubmit()); });
}
document.addEventListener('DOMContentLoaded', () => initOakmore());
document.addEventListener('shopify:section:load', event => initOakmore(event.target));
